import { useToggle } from "client/hooks/utils/useToggle";
import { HandleFile } from "client/types/HandleFile";
import { UploadOptions } from "client/types/UploadOptions";
import { joinFuncs } from "client/utils/joinFuncs";
import { stopPropagation } from "client/utils/stopPropagation";
import { UrlIcon } from "components/common/Icons/UrlIcon";
import { Translate } from "components/common/Translate/Translate";
import { UrlUploadModal } from "components/common/UrlUploadModal/UrlUploadModal";

export interface UrlUploadProps {
    handleFile: HandleFile;
    options: Omit<UploadOptions, "allowMultiple">;
}

export const UrlUpload = ({ handleFile, options }: UrlUploadProps) => {
    const { isOpen, open, onClose: close } = useToggle();

    return (
        <>
            <div
                className="flex items-center gap-2 py-3.5 pl-4 pr-12 hover:bg-gray-200 dark:hover:bg-darkSurface-300"
                onClick={stopPropagation(open)}
                data-testid="url-modal-opener"
            >
                <UrlIcon height={14} width={14} />
                <div className="capitalize">
                    <Translate keyName="from-url" />
                </div>
            </div>

            <UrlUploadModal
                isOpen={isOpen}
                close={joinFuncs(options.onClick, close)}
                handleFile={handleFile}
                options={options}
            />
        </>
    );
};
